export default __webpack_public_path__ + "static/media/cookies-banner.c0c3e4ce.jpg";